import type { MediaPipeFaceDetectorTfjsModelConfig } from '@tensorflow-models/face-detection/dist/tfjs/types';

export const FACE_DETECTOR_CONFIG = {
    runtime: 'tfjs',
    detectorModelUrl: 'https://cdn.n37z.com/models/v2/model.json'
} as MediaPipeFaceDetectorTfjsModelConfig;

export const FACE_DETECTOR_LOADING_TIMEOUT = 10000;
